module.exports = __webpack_public_path__ + "static/media/36.10b05c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/36.jpg
// module id = 982
// module chunks = 0